export default {
  CLIENT: "CHANNELASIA",
  // URL_CONFIG: "/config/index.json",
  URL_CONFIG: "https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/channelasia/config/index.json",
  DOMAIN_WHITELIST: "[]",
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  MUX_ANALYTICS_KEY: "g390j6uqqi612ienbuk94q10h",
  S3_REGION: "ap-southeast-2",
  S3_BUCKET: "events-public-assets",
  COGNITO_REGION: "ap-southeast-2",
  COGNITO_USER_POOL_ID: "ap-southeast-2_GacPp87tU",
  COGNITO_APP_CLIENT_ID: "4qo7os316k7g43srqnif4ee3uk",
  COGNITO_IDENTITY_POOL_ID: "ap-southeast-2:29ba053f-77cc-4e1c-9380-669f53fa7a66",
  BACKEND_REGION: "ap-southeast-2",
  ZENDESK_API_TOKEN: "42pzgqiuUL6qTOtljOIJWcELj2lJN3qA9ADBL9Ig"
}